// extracted by mini-css-extract-plugin
module.exports = {"showMore":"wcfo8","area":"_2j5K3","figure":"JVU3F","icon":"XGcdX","title":"kPfs0","keepRatio":"_6GTQ3","cardPortrait":"_2QYpf","cardLandscape":"csfeA"};